/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SignupStatus } from './';
import {
    SignupStatusFromJSON,
    SignupStatusFromJSONTyped,
    SignupStatusToJSON,
} from './';
import type { SignupStep } from './';
import {
    SignupStepFromJSON,
    SignupStepFromJSONTyped,
    SignupStepToJSON,
} from './';
import type { SignupType } from './';
import {
    SignupTypeFromJSON,
    SignupTypeFromJSONTyped,
    SignupTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface SignupStateResponse
 */
export interface SignupStateResponse {
    /**
     * 
     * @type {SignupStatus}
     * @memberof SignupStateResponse
     */
    status: SignupStatus;
    /**
     * 
     * @type {SignupStep}
     * @memberof SignupStateResponse
     */
    nextStep?: SignupStep;
    /**
     * 
     * @type {SignupType}
     * @memberof SignupStateResponse
     */
    signupType?: SignupType;
}

/**
 * Check if a given object implements the SignupStateResponse interface.
 */
export function instanceOfSignupStateResponse(value: object): value is SignupStateResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function SignupStateResponseFromJSON(json: any): SignupStateResponse {
    return SignupStateResponseFromJSONTyped(json, false);
}

export function SignupStateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignupStateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': SignupStatusFromJSON(json['status']),
        'nextStep': json['nextStep'] == null ? undefined : SignupStepFromJSON(json['nextStep']),
        'signupType': json['signupType'] == null ? undefined : SignupTypeFromJSON(json['signupType']),
    };
}

export function SignupStateResponseToJSON(value?: SignupStateResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': SignupStatusToJSON(value['status']),
        'nextStep': SignupStepToJSON(value['nextStep']),
        'signupType': SignupTypeToJSON(value['signupType']),
    };
}

